const ownLink = "https://opimisil.com/dV86k5FM";

const blogs = [
  {
    id: 1,
    date: "2025-01-28",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Estrategias para Maximizar tus Ganancias en Tragamonedas",
    descr:
      "Descubre consejos clave para mejorar tus resultados en tragamonedas y aprovechar al máximo cada giro.",
    fullText:
      "Las tragamonedas son uno de los juegos más populares en cualquier casino, y dominar sus estrategias puede marcar la diferencia.\n\n1. Establece un presupuesto antes de empezar a jugar. Esto te ayudará a evitar pérdidas mayores.\n\n2. Familiarízate con las reglas y características del juego. Comprender cómo funcionan las líneas de pago y los multiplicadores es esencial.\n\n3. Aprovecha los bonos y giros gratis. Estos pueden extender tu tiempo de juego sin costo adicional.\n\n4. Juega en máquinas con altos porcentajes de retorno al jugador (RTP). Esto incrementará tus probabilidades de ganar.\n\n5. Administra tu tiempo y evita sesiones largas. Descansar puede ayudarte a tomar decisiones más acertadas.\n\n6. Apuesta de forma estratégica. Empieza con apuestas pequeñas y aumenta gradualmente según los resultados.\n\n7. Explora las tragamonedas progresivas para oportunidades de grandes premios. Recuerda, estas requieren apuestas máximas para acceder a los jackpots.\n\n8. Diviértete y juega de manera responsable. Las tragamonedas deben ser un entretenimiento, no una forma de ingreso seguro.",
  },
  {
    id: 2,
    date: "2025-01-20",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Noticias: Regulaciones de Casinos en España",
    descr:
      "Conoce las últimas actualizaciones sobre las regulaciones de casinos y su impacto en el sector del entretenimiento.",
    fullText:
      "Las regulaciones en el sector de los casinos en España han experimentado cambios significativos en los últimos años.\n\n1. En 2025, se implementaron nuevas normativas para reforzar la seguridad y la transparencia en los juegos de azar.\n\n2. Las licencias ahora incluyen controles más estrictos para garantizar la protección del jugador.\n\n3. Los casinos están obligados a proporcionar herramientas de juego responsable para los usuarios.\n\n4. Las campañas de marketing tienen restricciones más estrictas para evitar promociones excesivas o engañosas.\n\n5. Se han reforzado las políticas contra el lavado de dinero, exigiendo verificaciones más rigurosas de los jugadores.\n\n6. Estas medidas buscan equilibrar el crecimiento de la industria y la protección del público.\n\n7. Según expertos, estas regulaciones han mejorado la percepción de los casinos como entornos seguros y confiables.\n\n8. Mantente informado sobre más actualizaciones en nuestro blog para conocer cómo estos cambios impactan a jugadores y operadores.",
  },
  {
    id: 3,
    date: "2025-01-15",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Cómo Elegir el Mejor Casino en Barcelona",
    descr:
      "Guía práctica para seleccionar el casino perfecto según tus necesidades y preferencias.",
    fullText:
      "Barcelona es conocida por su vibrante vida nocturna y sus emocionantes casinos.\n\n1. Investiga la reputación del casino. Consulta reseñas y opiniones de otros jugadores.\n\n2. Verifica las licencias y regulaciones. Asegúrate de que el casino opera legalmente.\n\n3. Explora los juegos disponibles. Busca un casino que ofrezca tus juegos favoritos.\n\n4. Considera los bonos y promociones. Las ofertas de bienvenida pueden marcar la diferencia.\n\n5. Evalúa la experiencia del cliente. Un buen servicio es esencial para disfrutar de tu visita.\n\n6. Examina las opciones de pago. Los métodos rápidos y seguros son un gran plus.\n\n7. Comprueba la ubicación y el ambiente. Un casino en una zona accesible y cómoda mejora la experiencia.\n\n8. Finalmente, prioriza tu diversión y juega de manera responsable. El mejor casino es aquel que cumple tus expectativas.",
  },
  {
    id: 4,
    date: "2025-01-10",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Noticias: El Crecimiento de los Casinos Online",
    descr:
      "Analizamos cómo los casinos online están transformando el panorama del juego en España.",
    fullText:
      "El auge de los casinos online ha revolucionado el entretenimiento en España.\n\n1. En 2024, el sector experimentó un crecimiento del 25% en comparación con años anteriores.\n\n2. Las plataformas ofrecen una variedad de juegos que rivalizan con los casinos físicos.\n\n3. La accesibilidad y conveniencia son factores clave para su popularidad.\n\n4. Los bonos y promociones han sido un gran atractivo para los nuevos usuarios.\n\n5. Sin embargo, las regulaciones también se han endurecido para proteger a los jugadores.\n\n6. Los casinos online ahora deben implementar políticas de juego responsable más estrictas.\n\n7. Expertos predicen que la industria seguirá creciendo gracias a la tecnología y la innovación.\n\n8. Mantente al tanto de las tendencias en nuestro blog para descubrir cómo aprovechar al máximo esta evolución.",
  },
  {
    id: 5,
    date: "2025-01-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Beneficios de Jugar en barcelona casino",
    descr:
      "Descubre por qué barcelona casino es la mejor opción para tus aventuras de juego.",
    fullText:
      "barcelona casino se ha convertido en un destino favorito para los jugadores por diversas razones.\n\n1. Ofrecemos una amplia variedad de juegos, desde tragamonedas hasta mesas de póker.\n\n2. Nuestras promociones exclusivas están diseñadas para maximizar tu diversión.\n\n3. Contamos con tecnología de punta para garantizar una experiencia segura y sin problemas.\n\n4. Nuestro servicio al cliente está disponible 24/7 para resolver tus dudas.\n\n5. Los métodos de pago son rápidos, seguros y adaptados a tus necesidades.\n\n6. Organizamos torneos y eventos especiales para mantener la emoción en todo momento.\n\n7. La interfaz intuitiva facilita el acceso a todos nuestros servicios.\n\n8. Juega en barcelona casino y vive una experiencia inolvidable llena de emoción y recompensas.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;
    img.alt = data.title;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;
    img.alt = blog.title;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
